export default __webpack_public_path__ + "static/media/Arrow.bb44b1d9.svg";